<template>
  <div v-if="isRunningInElectron && $route.name === 'TeachingAssistant'" class="import-resource">
    <label for="explore">
      <!--此input不会在页面中显示-->
      <input id="explore" ref="explore" type="file" name="Files" accept=".zip" style="display: none" />
      <!--此处自定义html内容，展示在页面中-->
      <div class="bg" />
    </label>
    <div v-if="loading" class="loading bullet-frame">
      <div class="bullet-frame-mask" />
      <div class="loading-box">
        <div class="loading-icon" />
        <div class="loading-text">{{ loadingText }}</div>
      </div>
    </div>
    <div v-if="showAuthorityBox" class="authority-box-mask" @click="showAuthorityBox = false" />
    <div v-if="showAuthorityBox" class="authority-box">
      <div class="authority-box-bg" />
      <div class="authority-box-close" @click="showAuthorityBox = false" />
      <div class="authority-box-text">{{ authorityText }}</div>
      <div class="partition" />
      <div v-if="authorityType === 'analysis'" class="authority-box-tips">客服：{{ serviceTel }}</div>
      <div v-if="authorityType === 'import'" class="authority-box-operation">
        <div class="authority-box-operation-item danger" @click="handleCover(true)">确定</div>
        <div class="authority-box-operation-item" @click="handleCover(false)">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { serviceTel } from '@/utils/dictionary.js'
import {
  copyFileData,
  decompressionAllFiles,
  renameFile,
  removeFile,
  mkdir,
  fetchOffline,
  readingFileDirectory,
  fetchFileName,
  fetchFile,
  fetchFileStatus,
  fetchFileNames
} from '@/utils/electronUtils.js'
import dayjs from 'dayjs'
import _ from 'lodash'

// 导入资源
export default {
  name: 'ImportResource',
  data() {
    return {
      isRunningInElectron: false,
      loading: false,
      loadingText: '正在导入资源，请稍等',
      showAuthorityBox: false,
      authorityType: 'import',
      resourceBundle: {},
      authorityText: '',
      baseFileUrl: '',
      serviceTel: serviceTel,
      flieName: '',
      olderVersionList: [],
      deleteList: []
    }
  },
  watch: {
    $route(to, form) {
      if (to.name === 'TeachingAssistant') {
        this.$nextTick(() => {
          this.importResource()
        })
      }
    }
  },
  async created() {
    this.isRunningInElectron = fetchOffline()
    if (this.isRunningInElectron) this.baseFileUrl = await window.electron.getUserDataOfflinePath()
  },
  mounted() {
    this.importResource()
  },
  destroyed() {
    if (this.$refs.explore) {
      this.$refs.explore.removeEventListener('change')
    }
  },
  methods: {
    importResource() {
      if (this.$refs.explore) {
        this.$refs.explore.addEventListener('change', async e => {
          this.loadingText = '正在导入资源，请稍等'
          this.loading = true
          this.resourceBundle = null
          try {
            const resourcesPath = `${this.baseFileUrl}\\resources`
            const tempPath = `${this.baseFileUrl}\\temp`
            const resourcesFileNames = await this.handleDirectory(resourcesPath, 'resources')
            await this.handleDirectory(tempPath, 'temp')
            const fileMap = {}
            if (resourcesFileNames && resourcesFileNames.length) {
              resourcesFileNames.forEach(name => {
                const obj = this.handleResources(name)
                if (obj) {
                  fileMap[obj.name] = obj
                } else {
                  fileMap[name] = null
                }
              })
            }
            const file = this.$refs.explore.files[0] || null
            this.flieName = fetchFileName(file.name)
            const fileObj = this.handleResources(this.flieName)
            if (!file) return
            const obj = {
              src: file.path,
              url: `${this.baseFileUrl}\\temp\\${file.name}`
            }
            const bookMap = this.$store.getters.bookMap || []
            const map = {}
            await copyFileData(obj)
            await decompressionAllFiles(`${this.baseFileUrl}\\temp`, map)
            if (_.isEmpty(map)) {
              this.loading = false
              this.$refs.explore.value = null
              this.authorityType = 'analysis'
              this.authorityText = '抱歉！当前资源包好像有问题，无法正常打开。请联系客服为您解决。'
              this.showAuthorityBox = true
              this.$refs.explore.value = null
              await this.resetDirectory()
              return
            }
            if (fileObj) {
              if (fileMap[fileObj.name]) {
                if (fileObj.unix >= fileMap[fileObj.name].unix) {
                  await removeFile(`${resourcesPath}/${fileMap[fileObj.name].fileName}`)
                } else {
                  this.loading = false
                  this.$refs.explore.value = null
                  this.authorityType = 'import'
                  this.authorityText = `当前已有更新版本的《${fileObj.name}》资源包，是否继续导入？如继续导入，将删除原有的资源包。`
                  this.resourceBundle = {
                    name: fileMap[fileObj.name].fileName,
                    path: `${resourcesPath}/${fileMap[fileObj.name].fileName}`
                  }
                  this.showAuthorityBox = true
                  return
                }
              }
            }
            this.olderVersionList = []
            this.deleteList = []
            for (const mapKey in map) {
              if (bookMap[mapKey]) {
                const fileStatus = await fetchFileStatus(bookMap[mapKey].filePath)
                if (fileStatus !== 'empty') {
                  if (map[mapKey].unix < bookMap[mapKey].unix) {
                    const dataUrl = bookMap[mapKey].filePath + '/book_config.json'
                    this.olderVersionList.push({
                      ...bookMap[mapKey],
                      data: fetchFile(dataUrl)
                    })
                  } else {
                    this.deleteList.push(bookMap[mapKey])
                  }
                }
              }
            }
            if (this.olderVersionList.length) {
              let text = ''
              this.olderVersionList.forEach(el => {
                text = text + (text ? '、《' : '《') + el.data.name + '》'
              })
              this.loading = false
              this.$refs.explore.value = null
              this.authorityType = 'import'
              this.authorityText = `当前已有更新版本的${text}图书资源，是否继续导入？如继续导入，将删除原有的资源包。`
              this.showAuthorityBox = true
              return
            }
            for (let i = 0; i < this.deleteList.length; i++) {
              await removeFile(this.deleteList[i].filePath)
            }
            await renameFile(
              `${this.baseFileUrl}\\temp\\${this.flieName}`,
              `${this.baseFileUrl}\\resources\\${this.flieName}`
            )
            this.loading = false
            this.$refs.explore.value = null
            this.readResource()
          } catch (e) {
            this.loading = false
            this.$refs.explore.value = null
            await this.resetDirectory()
            console.error(e)
            alert('资源加载失败，请尝试重新导入或更换其它资源包')
          }
        })
      }
    },
    /**
     * 处理资源目录
     * @param path 资源目录
     * @param type 资源目录类型 temp -> 临时; resources -> 正式
     * @return {Promise<*>}
     */
    async handleDirectory(path, type) {
      try {
        const fileStatus = await fetchFileStatus(path)
        // 如果目录不存在或为文件
        if (['empty', 'file'].includes(fileStatus)) {
          if (fileStatus === 'file') {
            await removeFile(path)
          }
          await mkdir(path)
        } else {
          const fileNames = await fetchFileNames(path)
          if (type === 'temp') {
            if (fileNames && fileNames.length) {
              await removeFile(path)
              await mkdir(path)
            }
          } else {
            return fileNames
          }
        }
      } catch (e) {
        this.loading = false
        this.$refs.explore.value = null
        await this.resetDirectory()
        alert('处理资源目录失败')
      }
    },
    handleResources(fileName) {
      const index = fileName.lastIndexOf('_')
      if (index < 0) return null
      let time = fileName.substring(index + 1, index + 13)
      if (time.length === 12 && !_.isNaN(Number(time))) {
        time = time.slice(0, 8) + ' ' + time.slice(8)
        const name = fileName.substring(0, index)
        const unix = dayjs(time, 'YYYYMMDD HHmm').unix()
        return {
          fileName,
          name,
          time,
          unix
        }
      } else {
        return null
      }
    },
    async readResource() {
      this.loadingText = '正在解析资源，请稍等'
      this.loading = true
      this.bookList = []
      try {
        const data = await readingFileDirectory(`${this.baseFileUrl}/resources`)
        const { list } = data
        if (!list) {
          this.loading = false
          this.$refs.explore.value = null
          return
        }
        await this.$store.dispatch('offline/setOfflineInfo', data)
        await this.$store.dispatch('offline/setlocalChange', true)
        this.loading = false
        this.$refs.explore.value = null
      } catch (e) {
        this.loading = false
        this.$refs.explore.value = null
        this.authorityType = 'analysis'
        this.authorityText = '抱歉！当前资源包好像有问题，无法正常打开。请联系客服为您解决。'
        this.showAuthorityBox = true
        console.error(e)
        // alert(e)
      }
    },
    async handleCover(bol) {
      this.showAuthorityBox = false
      this.loadingText = '正在导入资源，请稍等'
      this.loading = true
      try {
        if (bol) {
          for (let i = 0; i < this.olderVersionList.length; i++) {
            await removeFile(this.olderVersionList[i].filePath)
          }
          if (this.resourceBundle) {
            await removeFile(this.resourceBundle.path)
          }
          for (let i = 0; i < this.deleteList.length; i++) {
            await removeFile(this.deleteList[i].filePath)
          }
          await renameFile(
            `${this.baseFileUrl}\\temp\\${this.flieName}`,
            `${this.baseFileUrl}\\resources\\${this.flieName}`
          )
        }
        const tempPath = `${this.baseFileUrl}\\temp`
        await this.handleDirectory(tempPath, 'temp')
        this.loading = false
        this.$refs.explore.value = null
        this.readResource()
      } catch (e) {
        this.loading = false
        this.$refs.explore.value = null
        await this.resetDirectory()
        console.error(e)
        alert('资源加载失败，请尝试重新导入或更换其它资源包')
      }
    },
    // 清空临时目录
    async resetDirectory() {
      try {
        await removeFile(`${this.baseFileUrl}\\temp`)
        await mkdir(`${this.baseFileUrl}\\temp`)
      } catch (e) {
        console.error(e)
        alert('清空临时目录失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.import-resource {
  position: fixed;
  right: 144px;
  bottom: 60px;
  z-index: 999;
  width: 56px;
  height: 56px;
  background: linear-gradient(-90deg, #66adff 0%, #1976ff 100%);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  //border: 1px solid #E5E5E5;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  user-select: none;
  cursor: pointer;
  label {
    width: 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bg {
    width: 24px;
    height: 24px;
    background-image: url('../../assets/common/plus.png');
    background-size: 100% 100%;
    cursor: pointer;
  }
}
.bullet-frame {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;

  .bullet-frame-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .network-tips-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 120px 64px 45px;
    box-sizing: border-box;
    width: 720px;
    background: #ffffff;
    border-radius: 51px;

    .network-tips-box-close {
      position: absolute;
      width: 32px;
      height: 32px;
      top: 42px;
      right: 42px;
      z-index: 99999;

      background-image: url('../../assets/common/close.png');
      background-size: 100% 100%;
    }

    .network-tips-box-bg {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -100%);
      width: 592px;
      height: 240px;

      background-image: url('../../assets/login/authority-icon.png');
      background-size: 100% 100%;
    }

    .network-tips-text {
      font-size: 32px;
      font-weight: 400;
      color: #333333;
      line-height: 45px;
    }

    .network-tips-partition {
      margin: 20px auto 17px;
      height: 2px;
      background: #e5e5e5;
    }

    .network-tips-btn {
      display: flex;
      align-items: center;
      justify-content: center;

      .network-tips-btn-item {
        width: 280px;
        height: 86px;
        border-radius: 160px;
        font-size: 27px;
        font-weight: 400;
        color: #ffffff;
        line-height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.confirm {
          margin-right: 32px;
          background: #ff3c30;

          &:hover {
            background: #ea1d11;
          }
        }

        &.close {
          background: #1976ff;

          &:hover {
            background: #0565f3;
          }
        }
      }
    }
  }

  .loading-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: 420px;
    height: 240px;
    background: #ffffff;
    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.1);
    border-radius: 38px;
    padding: 45px 75px;

    .loading-icon {
      display: block;
      margin: 0 auto;
      width: 80px;
      height: 80px;
      background-image: url('../../assets/common/loading-icon.png');
      background-size: 100% 100%;

      animation: rotation 2s linear infinite;
      @keyframes rotation {
        from {
          transform: rotate(0);
        }

        to {
          transform: rotate(359deg);
        }
      }
    }

    .loading-text {
      margin: 32px auto 0;
      font-size: 27px;
      font-weight: 400;
      color: #333333;
      line-height: 38px;
    }
  }
}
.authority-box-mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9998;
}

.authority-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  padding: 75px 40px 28px;
  width: 450px;
  //height: 279px;
  background: #ffffff;
  border-radius: 32px;

  .authority-box-bg {
    position: absolute;
    top: -70px;
    left: 50%;
    transform: translateX(-50%);
    width: 370px;
    height: 150px;
    background-image: url('../../assets/login/authority-icon.png');
    background-size: 100% 100%;
  }

  .authority-box-close {
    position: absolute;
    top: 26px;
    right: 26px;
    width: 20px;
    height: 20px;
    background-image: url('../../assets/common/close.png');
    background-size: 100% 100%;
    cursor: pointer;
  }

  .authority-box-text {
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .partition {
    margin: 20px auto 17px;
    height: 1px;
    background: #e5e5e5;
  }
  .authority-box-tips {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
    color: #1976ff;
    line-height: 28px;
  }
  .authority-box-operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .authority-box-operation-item {
      width: 175px;
      height: 54px;
      background-color: #1976ff;
      border-radius: 54px;
      text-align: center;
      line-height: 54px;
      color: #ffffff;
      font-size: 17px;
      & + .authority-box-operation-item {
        margin-left: 20px;
      }
      &.danger {
        background-color: #ff3c30;
      }
    }
  }
}
</style>
